import Swal from 'sweetalert2';
import { Helmet } from 'react-helmet-async';
import Breadcrumbs from 'components/Breadcrumbs';
import { useLocation } from 'react-router-dom';

// import banner from '../assets/final/bath/bath3.webp';
const banner =
  'https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp';

export const Careers = () => {
  const location = useLocation();
  const EMAIL_ACCESS_KEY = process.env.REACT_APP_EMAIL_ACCESS_KEY;

  const onSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    formData.append('access_key', EMAIL_ACCESS_KEY);

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: 'Success!',
        text: 'Application submitted successfully!',
        icon: 'success'
      });
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Application failed to send.',
        icon: 'error'
      });
    }
  };

  return (
    <div>
      <Helmet>
        <title>Careers | Oak and Stone</title>
        <meta
          name="description"
          content="Join our team at Oak and Stone. We are always looking for skilled professionals to join our team. Fill out the form below and let us know why you'd be a great fit!"
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Careers | Oak and Stone" />
        <meta
          property="og:description"
          content="Join our team at Oak and Stone. We are always looking for skilled professionals to join our team. Fill out the form below and let us know why you'd be a great fit!"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp"
        />
        <meta
          property="og:url"
          content="https://oakandstoneremodel.com/careers"
        />
        <meta property="og:type" content="website" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers | Oak and Stone" />
        <meta
          name="twitter:description"
          content="Join our team at Oak and Stone. We are always looking for skilled professionals to join our team. Fill out the form below and let us know why you'd be a great fit!"
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp"
        />
        <meta
          name="twitter:url"
          content="https://oakandstoneremodel.com/careers"
        />
        <link rel="canonical" href="https://oakandstoneremodel.com/careers" />
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Careers | Oak and Stone',
          url: 'https://oakandstoneremodel.com/careers',
          description:
            "Join our team at Oak and Stone. We are always looking for skilled professionals to join our team. Fill out the form below and let us know why you'd be a great fit!"
        })}
      </script>
      {/* Careers Header */}
      <div className="h-[45vh] w-full relative">
        <div className="absolute top-0 left-0 z-10 w-full h-full">
          <div className="grid content-center w-full h-full">
            <h1 className="text-4xl text-center text-white uppercase">
              Careers
            </h1>
            <div className="mx-auto my-6 w-60 h-1 bg-white"></div>
            <div className="mx-auto mt-6 w-10/12 text-lg font-normal tracking-widest text-center text-white md:w-full">
              JOIN OUR TEAM AT OAK AND STONE
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-[35%]"></div>
        <img
          src={banner}
          className="object-cover flex-shrink-0 w-full h-full bg-no-repeat"
          alt="Oak and Stone careers banner"
        />
        <Breadcrumbs pathname={location.pathname} />
      </div>

      {/* Form Section */}
      <div className="max-w-[1200px] mx-auto md:grid md:grid-cols-2 px-6 py-16">
        {/* left text section */}
        <div className="mb-10 w-full md:w-11/12 md:mb-0">
          <h2 className="uppercase text-[27px]">JOIN OUR GROWING TEAM!</h2>
          <div className="w-full h-1 bg-[#8b93c9] my-5"></div>
          <p className="text-lg">
            Our team is based in Tremonton, Utah and expanding, making
            incredible progress, and looking for talented individuals to join
            us. We would love to hire passionate professionals eager to grow
            with us!
          </p>
          <p className="mt-5 text-lg">
            We are always looking for skilled professionals to join our team.
            Fill out the form below and let us know why you'd be a great fit!
          </p>
        </div>

        {/* form */}
        <div className="p-3 w-full bg-gray-300 h-max">
          <form onSubmit={onSubmit}>
            <input
              type="text"
              name="name"
              placeholder="FULL NAME*"
              required
              className="p-3 mb-4 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              name="email"
              placeholder="EMAIL*"
              required
              className="p-3 mb-4 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="phone"
              name="phone"
              placeholder="PHONE*"
              required
              className="p-3 mb-4 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <input
              type="text"
              name="location"
              placeholder="LOCATION*"
              required
              className="p-3 mb-4 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <textarea
              name="experience"
              placeholder="RELEVANT EXPERIENCE"
              className="p-3 mb-2 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>

            <textarea
              name="message"
              placeholder="ADDITIONAL MESSAGE"
              className="p-3 mb-4 w-full text-sm placeholder:text-black focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>

            <button
              type="submit"
              className="p-3 w-full text-white bg-primary rounded-md transition duration-200 hover:bg-primary-hover">
              Submit Application
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
